export const generalKey = 'product_shp3_mbs-'; /**TODO 临时使用，待换 */
export const whiteLocaleList = ['us'];
export const productPageUrl = 'ocean-pro-home-solar-battery';
